/* Preserve app embeds; purchase visibility controls only their collapsed launchers. */
(() => {
  const initialize = () => {
    if (!document.querySelector('.nxt-clean-pdp')) return;
    document.body.classList.add('nxt-clean-product-page');
    const purchase=document.querySelector('.nxt-clean-pdp .product-form-buttons');
    if(purchase && !purchase.dataset.nxtObserved){
      purchase.dataset.nxtObserved='true';
      new IntersectionObserver(entries=>{
        document.body.classList.toggle('nxt-purchase-visible',entries[0].isIntersecting);
      },{threshold:0}).observe(purchase);
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true});
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
